import styled from "styled-components";

export const CreateAwaContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr
    align-items: center;
`;
export const Header = styled.div`
  font-size: 1rem;
  font-weight: 400;
  grid-column: 1/-1;
`;
export const Text = styled.div`
  font-size: 1rem;
  font-weight: 300;
  margin-right: 2rem;
`;
export const Label = styled.div`
  color: #0a85c7;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.5rem;
  grid-column: 1/-1;
  margin: 1rem 0;
`;
export const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`;
